import React from 'react';
import { LockClosedIcon, LockOpenIcon } from '@heroicons/react/24/outline';
import { useGdpr } from '../../../../context/GdprContext';
import { useCurrentUser } from '../../../../context/CurrentUserContext';
import { Role } from '../../../../generated/graphql';

const GDPR_ROLES = [Role.Admin, Role.Nurse, Role.Analyst, Role.Content];

export const GdprToggle: React.FC = () => {
  const { roles } = useCurrentUser();
  const { hasAccess, requestAccess, lock, loading } = useGdpr();

  if (loading) return null;
  if (!roles.some(r => GDPR_ROLES.includes(r))) return null;

  if (hasAccess) {
    return (
      <button
        onClick={lock}
        className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium bg-green-50 text-green-700 border border-green-200 hover:bg-green-100 transition-colors"
        title="Click to re-anonymize user identities"
        data-testid="gdpr-toggle-unlock"
      >
        <LockOpenIcon className="h-3.5 w-3.5" />
        Identities Revealed
      </button>
    );
  }

  return (
    <button
      onClick={requestAccess}
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium bg-amber-50 text-amber-700 border border-amber-200 hover:bg-amber-100 transition-colors"
      title="User identities are anonymized. Click to reveal with GDPR justification."
      data-testid="gdpr-toggle-lock"
    >
      <LockClosedIcon className="h-3.5 w-3.5" />
      Anonymized
    </button>
  );
};
